<template>
	<div>
		<el-card shadow="never">
			<el-form ref="form" :inline="true" :model="formData" label-width="100px" size="small">
				<el-form-item label="项目">
                    <el-input size="small" v-model="formData.projectName" placeholder="项目" :readonly="true"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select  clearable size="small" v-model="formData.meterType" placeholder="请选择类型" :readonly="true" :disabled="true">
                        <el-option v-for="item in meterType" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="总价">
                    <el-input size="small" v-model="formData.price" placeholder="项目" :readonly="true">
                        <template slot="append">
                            <span>元</span>
                        </template>
                    </el-input>
                </el-form-item>
            </el-form>
            <el-table :data="tableData" v-loading="subTableLoading" row-key="feeitemId" border :stripe="true">
                <el-table-column width="250" prop="feeitemId" label="收费项目" align="right">
                    <template slot-scope="scope">
                        <el-select  clearable size="small" v-model="scope.row.feeitemId" placeholder="请选择类型">
                            <el-option v-for="item in getChargeFeeitemList" :key="item.value" :disabled="item.disabled" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column width="180" prop="price" label="单价(元)" align="right">
                    <template slot-scope="scope">
                        <el-input style="width: 100px" size="small" v-model="scope.row.price" placeholder="单价" @keyup.native="changePrice(scope.$index)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column width="80" prop="percent" label="占比" align="right">
                    <template slot-scope="scope">
                        <span>{{ scope.row.percent }}%</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="right">
                    <template slot-scope="scope">
                        <el-button
                            style="padding: 12px;"
                            type="primary"
                            v-show="tableData.length - 1 == scope.$index"
                            round
                            @click="add()"
                            icon="el-icon-plus"
                        ></el-button>
                        <el-button
                            style="padding: 12px;"
                            type="danger"
                            v-show="tableData.length > 1"
                            round
                            @click="remove(scope.$index)"
                            icon="el-icon-minus"
                        ></el-button>
                    </template>
                </el-table-column>
            </el-table>

			<div class="form-buttons-center">
				<el-button size="small" type="primary" :loading="saveLoading" @click="doSaveConfigSub">确 定</el-button>
				<el-button size="small" @click="doClose">取 消</el-button>
			</div>
		</el-card>
	</div>
</template>
<script>
import "@/assets/scss/common.scss";
import dlgForm from "@/mixin/dlgForm";
import { meterType } from "@/dict/meterDict";
import NP from "number-precision";
import { get, put, alertMultiMessage } from "@/assets/common/request";
import { pick, assign, sum } from "lodash";
export default {
	name: "ConfigFeeitemForm",
	mixins: [dlgForm],
	data() {
		return {
            meterType,
            chargeFeeitemList: [],
            tableData: [],
            subTableLoading: false
		};
	},
	methods: {
        doSaveConfigSub() {
			const formData = pick(this.formData, "id", "projectId", "price");
			const data = assign(formData);
			const subList = this.tableData;
			for (let i = 0; i < subList.length; i++) {
				if (!subList[i].feeitemId) {
					this.$message(`存在收费项未选择`);
					return false;
				}
			}
			if (!subList || subList.length == 0) {
				this.$message("请先选择之前的收费项");
				return false;
			}
			data.subList = this.tableData.filter((item) => item.feeitemId);
			const url = "meter/web/feeitem/saveConfig";
			put(url, data).then((data) => {
				this.saveLoading = false;
                this.doClose();
                this.$emit("search");
                alertMultiMessage(data);
            })
            .finally(() => {
                this.saveLoading = false;
            });
		},
        listChargeFeeitem() {
			const url = "meter/web/feeitem/listChargeFeeitem";
			get(url).then((data) => {
				if (data.data) {
					this.chargeFeeitemList = data.data;
				}
			});
		},
        listSubFeeitem() {
            let subList = [];
			const url = `meter/web/feeitem/listSubFeeitem/${this.formData.id}`;
            this.subTableLoading = true;
			get(url)
            .then((data) => {
				if (data.data && data.data.length != 0) {
					subList = data.data;
				} else {
					subList.push({
						id: "",
						price: 0,
						percent: 0,
					});
				}
				this.tableData = subList;
                this.subTableLoading = false;
			})
            .finally(() => {
                this.subTableLoading = false;
            });
        },
        calPercent() {
			const prices = this.tableData.map((item) => Number.parseFloat(item.price));
			const sumPrice = sum(prices);
			this.formData.price = sumPrice;
			if (sumPrice != 0) {
				for (let i = 0; i < this.tableData.length; i++) {
					const price = this.tableData[i].price;
					const percent = NP.round(NP.divide(price, sumPrice), 2);
					this.tableData[i].percent = NP.round(percent * 100, 2);
				}
			}
		},
		changePrice(index) {
			this.calPercent();
		},
		add() {
			const error = this.tableData.find((item) => !item.feeitemId);
			if (error) {
				this.$message("请先选择之前的收费项");
				return;
			}
			this.tableData.push({
				id: "",
				price: 0,
				percent: 0,
			});
		},
		remove(index) {
			this.tableData.splice(index, 1);
			this.calPercent();
		},
	},
    computed: {
		getChargeFeeitemList() {
			let ids = this.tableData.filter((item) => item.feeitemId).map((item) => item.feeitemId);
			const result = this.chargeFeeitemList.map((item) => Object.assign(item, { disabled: ids.includes(item.value) }));
			return result;
		},
	},
    mounted() {
        this.formData.price = this.formData.price || 0;
        this.listChargeFeeitem();
        this.listSubFeeitem();
    }
};
</script>
<style scoped>
.cell .el-input--small {
    width: 100px;
}
.cell .el-input--small .el-input--inner {
    width: 100%;
}
</style>